import React from 'react';
import clsx from 'clsx';
import { EXPENSE_SRC, EXPENSE_SRC_NAME } from '@/config/constants';
import styles from './ExpenseBillsTable.module.scss';

export default function ExpenseBillsTable({
  expenseBills,
  order,
  onSort,
  onEdit,
  onDelete,
  onLoadMore,
  saving,
  loading,
  hasMore,
  canEditExpenseHistory,
  canDeleteColumn,
}) {
  return (
    <React.Fragment>
      <header
        className={clsx(styles.header, {
          [styles.full]: canEditExpenseHistory,
        })}
      >
        <div className={styles.heading}>STT</div>
        <div
          className={clsx(styles.heading, 'clickable')}
          onClick={() => onSort()}
        >
          Ngày chi
          <i
            className={clsx(styles.sortIcon, 'fa-solid', {
              'fa-sort-up': order === 'ASC',
              'fa-sort-down': order === 'DESC',
              'fa-sort': order === '',
            })}
          />
        </div>
        <div className={styles.heading}>Người chi</div>
        <div className={styles.heading}>Khoản chi</div>
        <div className={styles.heading}>Số tiền</div>
        <div className={styles.heading}>Ghi chú</div>
        {canEditExpenseHistory && (
          <div className={styles.heading}>Sửa</div>
        )}
        <div className={styles.heading}>Xóa</div>
      </header>

      <div
        className={styles.content}
        onScroll={(e) => {
          if (
            e.currentTarget.scrollHeight -
              e.currentTarget.scrollTop <=
            e.currentTarget.clientHeight + 20
          )
            onLoadMore();
        }}
      >
        {expenseBills.map((expenseBill) => (
          <div
            className={clsx(styles.row, {
              [styles.full]: canEditExpenseHistory,
            })}
            key={expenseBill.id}
          >
            <div className={clsx(styles.cell, 'text-center')}>
              {expenseBill.id}
            </div>
            <div className={clsx(styles.cell, 'text-center')}>
              <span className={styles.dateTime}>
                {new Date(expenseBill.createdAt).toLocaleDateString(
                  'vi-VN',
                )}
              </span>
              <span className={styles.dateTime}>
                {new Date(expenseBill.createdAt).toLocaleTimeString(
                  'vi-VN',
                )}
              </span>
            </div>
            <div className={clsx(styles.cell, 'text-uppercase')}>
              {expenseBill.employee
                ? expenseBill.employee.displayName
                : ''}
            </div>
            <div className={clsx(styles.cell, 'text-uppercase')}>
              {expenseBill.expense ? expenseBill.expense.name : ''}
              {expenseBill.src != null &&
                expenseBill.src !== EXPENSE_SRC.QUOC_TIEN && (
                  <span style={{ color: 'blue' }}>
                    {' '}
                    ({EXPENSE_SRC_NAME[expenseBill.src]})
                  </span>
                )}
            </div>
            <div className={clsx(styles.cell, 'text-center')}>
              {Number(expenseBill.price).toLocaleString('vi-VN', {
                style: 'currency',
                currency: 'VND',
              })}
            </div>
            <div className={styles.cell}>{expenseBill.note}</div>
            {canEditExpenseHistory && (
              <div
                className={clsx(
                  styles.cell,
                  'text-center',
                  'clickable',
                )}
                onClick={() => !saving && onEdit(expenseBill)}
              >
                <i className={clsx(styles.icon, 'fas fa-edit')} />
              </div>
            )}
            <div
              className={clsx(
                styles.cell,
                'text-center',
                {
                  [styles.disabled]: !canDeleteColumn(expenseBill),
                  'clickable': canDeleteColumn(expenseBill),
                },
              )}
              onClick={() =>
                !saving &&
                canDeleteColumn(expenseBill) &&
                onDelete(expenseBill.id)
              }
            >
              <i className={clsx(styles.icon, 'fa fa-trash')} />
            </div>
          </div>
        ))}
        {loading && <p role="status">Đang tải...</p>}
        {hasMore && (
          <button disabled={loading || saving} onClick={onLoadMore}>
            Tải thêm
          </button>
        )}
      </div>
    </React.Fragment>
  );
}
